<template>
  <VueSidePanel
    v-model="isSidePanelOpen"
    transition-name="slide-left"
    width="58%"
    side="left"
    body-class="bbSidePanelBody bbSidePanelBody-Item"
    panel-color="transparent"
    :z-index="5000"
  >
    <template #default>
      <div class="bb-artefact-side-panel-content mt-2 px-4">
        <ArtefactCard
          :artefact="artefact"
          :artefactNames="artefactNames"
          @add-campaign-artefact="$emit('add-campaign-artefact', $event)"
          @update-campaign-artefact="$emit('update-campaign-artefact', $event)"
          @delete-campaign-artefact="$emit('delete-campaign-artefact', $event)"
          @close-artefact-panel="$emit('close-artefact-panel', $event)"
        />
      </div>
    </template>
  </VueSidePanel>
</template>

<script>
import ArtefactCard from './ArtefactCard.vue'
import { VueSidePanel } from 'vue3-side-panel'
import 'vue3-side-panel/dist/vue3-side-panel.css'
//---------
// scripts
//---------
export default {
  name: 'ArtefactSidePanel',
  emits: [
    'add-campaign-artefact',
    'update-campaign-artefact',
    'delete-campaign-artefact',
    'close-artefact-panel',
  ],
  //------------
  // components
  //------------
  components: {
    VueSidePanel,
    ArtefactCard,
  },
  //-------
  // props
  //-------
  props: {
    artefact: {
      type: Object,
      required: false,
      default: null,
    },
    artefactNames: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  //------
  // data
  //------
  data() {
    return {
      isSidePanelOpen: true,
    }
  },
  //----------------------
  // computed
  //----------------------
  watch: {
    isSidePanelOpen(newValue) {
      if (!newValue) {
        this.emitter.emit('close-artefact-side-panel', false)
      }
    },
  },
  //----------------------
  // mounted
  //----------------------
  mounted() {
    this.emitter.on('close-artefact-side-panel', (ind) => {
      this.isSidePanelOpen = ind
    })
  },
}
</script>

<style scoped>
.bb-artefact-side-panel-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.bb-artefact-side-panel-content :deep(.bb-artefact-card) {
  height: 100%;
}
</style>
